import { InputField } from '../atomic-elements/molecules/fields/input-field/input-field'
import { JSONInputFactory } from '../json-elements/higher-order-components/json-input-factory'

export const UIInputField = JSONInputFactory(InputField)
